import { render, staticRenderFns } from "./flag-applicant.component.vue?vue&type=template&id=b8098f4c"
import script from "./flag-applicant.component.ts?vue&type=script&lang=ts&external"
export * from "./flag-applicant.component.ts?vue&type=script&lang=ts&external"
import style0 from "./flag-applicant.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports